<template>
  <div class="header header-i">
    <h1 v-if="isHome">
      <router-link to="/home">
        <img :src="$baseImgUrl + seoSettings.logo" alt="" />
      </router-link>
    </h1>
    <a v-else class="back" @click="goBack"
      ><span><img src="@/assets/img/back.png" alt="" /></span
      ><span>上一頁</span></a
    >
    <div class="r-txt" v-if="loginState">
      <strong>{{ checkName }} 你好</strong>
      <span class="sound" v-on:click="vodSnd()">
        <img
          v-if="objConf.bolSnd"
          src="@/assets/img/snd_on.png"
          class="snd on"
        />
        <img
          v-else
          src="@/assets/img/snd_off.png"
          class="snd off"
        />
      </span>
      <router-link
        :to="{ name: 'msg', params: { strCat: '4' } }"
        style="cursor: pointer"
        class="msg"
      >
        <span v-show="intMsgUnr > 0">
          {{ Number(intMsgUnr) > 99 ? "99+" : intMsgUnr }}
        </span>
      </router-link>

      <router-link to="/cart/cart" style="cursor: pointer" class="car">
        <span
          v-if="cartList.length"
          v-text="Number(cartList.length) > 99 ? '99+' : cartList.length"
          >{{ cartList.length }}</span
        >
      </router-link>
      <router-link to="/nav" style="cursor: pointer" class="menu">
      </router-link>
    </div>
    <div class="r-txt noLogin" v-else>
      <router-link class="border" to="/reg">會員註冊</router-link>
      <router-link class="border" to="/login">登入</router-link>
      <router-link class="border" to="/download">APP下載</router-link>
    </div>
    <div class="goTop">
      <div v-if="!isHome" @click="$router.push('/home')">
        <img src="@/assets/img/home-icon.svg" alt="" /><br /><span>回首頁</span>
      </div>
      <div v-if="isGoTop" @click="scrollTo(0, 400)">
        <img src="@/assets/img/top-white-icon.svg" alt="" /><br /><span
          >回頂部</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "CompHeader",
  props: {},
  computed: {
    ...mapGetters({
      loginState: "loginState",
      webMode: "webMode",
      cartList: "product/cartList",
    }),
    ...mapState({
      seoSettings: (state) => state.website.seoSettings,
      userInfo: (state) => state.member.userInfo,
      messageList: (state) => state.notice.messageList,
      ActivityMsgNoReadCount: (state) => state.news.ActivityMsgNoReadCount,
      msgNoReadCount: (state) => state.notice.msgNoReadCount,
      // cartList: state => state.product.cartList
    }),
    intMsgUnr() {
      return this.ActivityMsgNoReadCount + this.msgNoReadCount;
    },
    checkName(){
      let name = this.userInfo.name;
      if(name.length > 4){
        name = name.substr(0,4)
      }
      return name
    }
  },
  data() {
    return {
      isHome: true,
      isGoTop: false,
      objConf: JSON.parse(localStorage.getItem("objConf") || '{"bolSnd":true}'),
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.isHome = to.name === "home" ? true : false;
      },
    },
  },
  methods: {
    vodSnd() {
      this.objConf.bolSnd = !this.objConf.bolSnd;
      localStorage.setItem("objConf", JSON.stringify(this.objConf));
    },
    scrollTo(to, duration) {
      // window.scrollTo({
      //   top: 0,
      //   behavior: "smooth"
      // })
      let htmlElement =
        document.documentElement.scrollTop > 0
          ? document.documentElement
          : document.body;
      var start = htmlElement.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;

      var animateScroll = () => {
        currentTime += increment;
        var val = this.easeInOutQuad(currentTime, start, change, duration);
        htmlElement.scrollTop = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    },
    easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    },
    handleScroll(event) {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      this.isGoTop = top > 200 ? true : false;
    },
    goBack() {
      this.$store.commit("website/setAnimateName", "slide-right");
      if (this.$route.matched[0].name === "games") {
        this.$router.push("/home");
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.objConf = this.objConf;
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.sound {
  float: left;
  display: block;
  width: 0.4rem;
  height: 0.8rem;
  margin-top: 0.18rem;
  margin-left: 0.18rem;
  position: relative;
}
.sound img {
  width: .36rem;
  padding-top: .2rem;
}

/* @import "~@/assets/css/public.css"; */
</style>
